import Card from '@/components/Card';
import { Uploader } from '@/components/ui/Uploader/Uploader';
import { ATTACHMENT_TYPES } from '@/consts';

import { useLingui } from '@lingui/react';

export const INVOICES_RECEIPTS_OR_OTHER_DOCUMENTS_NAME =
  'invoices_receipts_or_other_documents';

const InvoicesReceiptsOrOtherDocuments = () => {
  const { i18n } = useLingui();

  const instructionProps = {
    title: i18n.t('Dołącz wszystkie strony dokumentu'),
    steps: [
      i18n.t('Dołącz wszystkie strony dokumentu'),
      i18n.t('Upewnij się, że wszystkie dane są w pełni widoczne'),
      i18n.t(
        'Jeśli przesyłasz zdjęcia – zadbaj o dobrą jakość, brak rozmyć i zasłoniętych fragmentów.'
      ),
      i18n.t('W przypadku plików zabezpieczonych hasłem – dołącz hasło.'),
    ],
  };

  return (
    <div>
      <Card>
        <Uploader
          title={i18n.t('Faktury, rachunki lub inne dokumenty?')}
          instructionProps={instructionProps}
          inputFieldName={INVOICES_RECEIPTS_OR_OTHER_DOCUMENTS_NAME}
          required={true}
          attachmentTypeId={ATTACHMENT_TYPES.FAKTURA_ZA_NAPRAWE}
        />
      </Card>
    </div>
  );
};

export default InvoicesReceiptsOrOtherDocuments;
